import React from "react";

const Details = () => {
  const styles = {
    container: {
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",
      padding: "10px",
    },
    column: {
      flex: 1,
      padding: "20px",
      color: "white",
      fontFamily: "Arial, sans-serif",
      margin: "5px",
      borderRadius: "8px",
      boxSizing: "border-box",
    },
    yellow: {
      backgroundColor: "#fde6a1",
      color: "#000",
    },
    orange: {
      backgroundColor: "#fbb7a2",
    },
    pink: {
      backgroundColor: "#fcb8d2",
    },
    blue: {
      backgroundColor: "#a4bdfc",
    },
    teal: {
      backgroundColor: "#9de8db",
    },
    responsive: {
      flexDirection: "column",
    },
  };

  const isMobile = window.innerWidth <= 768;

  return (
    <div style={{ ...styles.container, ...(isMobile ? styles.responsive : {}) }}>
      <div style={{ ...styles.column, ...styles.yellow }}>
        <h2>📄 WHY OUR SCHOOL</h2>
        <p>
        As part of our commitment to improving educational standards in the state, we have strived to offer a comprehensive curriculum coupled with state-of-the-art facilities. Our aim is to provide the best resources for both our students and staff, ensuring a quality learning experience. By fostering a culture of innovation and forward-thinking, we aspire to stand out in the field of education, equipping our students with the skills and vision they need for a bright future.
        </p>
      </div>
      <div style={{ ...styles.column, ...styles.orange }}>
        <h2>🎵 TEACHERS</h2>
        <p>
        Our faculty forms the cornerstone of our educational institution. Our educators are instrumental in creating an engaging and interactive learning environment. As both mentors and facilitators, they inspire curiosity and a passion for learning, guiding students on their journey for knowledge. With a low student-to-teacher ratio, we ensure that each student receives personalized, focused attention to foster their individual growth and success.
        </p>
      </div>
      <div style={{ ...styles.column, ...styles.pink }}>
        <h2>🍃 CLASSES</h2>
        <p>
        Our classrooms are designed to be spacious and well-ventilated, with lighting that meets international standards. To ensure personalized attention, we maintain a limited number of students in each class. The furniture is thoughtfully designed to prioritize student comfort, creating an optimal learning environment. Additionally.
        </p>
      </div>
      <div style={{ ...styles.column, ...styles.blue }}>
        <h2>💬 EVENTS</h2>
        <p>
        At Jamia Nida-e-Islam, we believe that education extends far beyond the confines of textbooks. True learning emerges from self-inquiry, research, thoughtful discussions, extra reading, and nurturing the innate curiosity of young minds. We are dedicated to the holistic development of our students, focusing on engaging all of their senses. The school promotes experiential learning through various activities.
        </p>
      </div>
      <div style={{ ...styles.column, ...styles.teal }}>
        <h2>📜 PROGRAMS</h2>
        <p>
        At our institution, we believe in the philosophy of collaboration over competition, focusing on the best approach rather than sticking to fixed methods. In addition to academics, we place a strong emphasis on activities that foster creativity and communication, such as public speaking, debates, and singing. We are also committed to shaping our students' character by encouraging positive habits and manners in their daily interactions.
        </p>
        {/* <p>
          Children not only enjoy these activities and competitions but they
          also learn about culture and tradition of our society from it.
          Students are encouraged to pursue and polish their talent through
          these programs.
        </p> */}
      </div>
    </div>
  );
};

export default Details;
